import * as imageClientAPI from '@wix/image-client-api/dist/imageClientSDK';

const TRANSPARENT_IMAGE_URL =
  'https://static.wixstatic.com/media/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png/v1/fit/w_297,h_206/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png';

class ImageClientApiService {
  DEFAULT_WATERMARK_DATA = {
    position: 9,
    size: 40,
    opacity: 40,
    imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
    imageRatio: 1.42517815,
  };

  getWatermarkStr = watermark => {
    return `${watermark.imageUrl}-${watermark.opacity}-${watermark.position}-${watermark.size}`;
  };

  getImageItemUrl = (item, { targetWidth, targetHeight } = {}) => {
    return item
      ? imageClientAPI.getScaleToFillImageURL(
        `media/${item.name}`,
        item.photoMetadata.width,
        item.photoMetadata.height,
        targetWidth || item.photoMetadata.width,
        targetHeight || item.photoMetadata.height,
      )
      : TRANSPARENT_IMAGE_URL;
  };

  formatImageUrlToCodeFormat = (item, watermarkStr) => {
    return (
      `wix:image://v1/${item.name}/${item.name}#originWidth=${item.photoMetadata.width}&originHeight=${item.photoMetadata.height}` +
      (watermarkStr && `&watermark=${watermarkStr}`)
    );
  };

  getWixCodeImageWithWatermark = (item, watermark) => {
    const watermarkStr = this.getWatermarkStr(
      watermark || this.DEFAULT_WATERMARK_DATA,
    );
    return this.formatImageUrlToCodeFormat(item, watermarkStr);
  };

  getImageItemUrlWithWatermark = (item, watermark) => {
    // const MAX_SIZE = 10000
    // const ratio = item.photoMetadata.width / item.photoMetadata.height;
    // let targetWidth, targetHeight;
    // if (ratio < 1) {
    //   targetHeight = MAX_SIZE;
    //   targetWidth = MAX_SIZE * ratio;
    // } else {
    //   targetHeight = MAX_SIZE * ratio;
    //   targetWidth = MAX_SIZE;
    // }
    const itemUrl = this.getImageItemUrl(item);
    if (item && item.isSecure) {
      return (
        itemUrl &&
        itemUrl.replace(
          /\/([^\/]*)$/,
          ',wm_' +
          this.getWatermarkStr(watermark || this.DEFAULT_WATERMARK_DATA) +
          '/$1',
        )
      );
    }
    return itemUrl;
  };
}

export default new ImageClientApiService();
